import { takeEvery, call, all, put } from 'redux-saga/effects';
import axios from 'axios';
import {
    FETCH_SELF_EVALUATION_ICONS,
    SELF_EVALUATION_ICONS_FETCHING,
    SELF_EVALUATION_ICONS_SUCCESS,
    SELF_EVALUATION_ICONS_ERROR
} from 'actions/ActionTypes';

// worker
export function* fetchSelfEvaluationIcons() {
    try {
        yield put({
            type: SELF_EVALUATION_ICONS_FETCHING
        });

        const response = yield call(axios.get, `/web-data/self-evaluation/self-evaluation-icons.json`, {
            baseURL: '/'
        });

        yield put({
            type: SELF_EVALUATION_ICONS_SUCCESS,
            response
        });
    } catch (e) {
        yield put({
            type: SELF_EVALUATION_ICONS_ERROR
        });
    }
}

// watcher
export const workoutExecutionSagas = [takeEvery(FETCH_SELF_EVALUATION_ICONS, fetchSelfEvaluationIcons)];
